












































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import MicroshftLogin from "../../directives/microsoft-signin";
import {
  loginImagePad,
  loginImageIphone678,
  loginImageIphone678P,
  loginImageIphonex,
  loginImageIphonexr,
  loginImageIphonexsMax,
  deviceWidth
} from "@/config/general";
import { event } from "../../libs/utils";
@Component({
  name: "Login",
  directives: {
    MicroshftLogin
  }
})
export default class Login extends Vue {
  msClientId: string = "38c9f5d1-ddf5-41a0-b011-77e88c8778bb";
  loginImage: string = loginImagePad;

  googleLogin() {
    event("googleLogin", "");
  }

  microsoftLogin() {
    event("microsoftLogin", "");
  }

  @Mutation("handleMerchId")
  private handleMerchId!: Function;

  @Mutation("handleOptions")
  handleOptions!: Function;
  reload() {
    this.handleOptions({
      token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IllNRUxIVDBndmIwbXhvU0RvWWZvbWpxZmpZVSJ9.eyJhdWQiOiIzOGM5ZjVkMS1kZGY1LTQxYTAtYjAxMS03N2U4OGM4Nzc4YmIiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vZTlkYWJlMGItOWY3OC00MmUyLTlmMGMtZDI4YTcwMmNlYzBmL3YyLjAiLCJpYXQiOjE1ODY0MzA1NDYsIm5iZiI6MTU4NjQzMDU0NiwiZXhwIjoxNTg2NTE3MjQ2LCJhaW8iOiJBVFFBeS84UEFBQUF2L1lVL3ZsV2VORWM3bVVJSkJlSjJyNEhRZWV0ZHIzYjBPQW5WbUxTcUo2OUpvZXpZWlQvNzNtNkpiVWlEckIvIiwibmFtZSI6ImFuc29uIiwibm9uY2UiOiI2Nzg5MTAiLCJvaWQiOiJlMzA5NmMwMS1jYjA2LTRkNWUtOTY3MC0zYTU3Mzk4YTg5M2QiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJhbnNvbnRlc3RAeWFtaW1lYWwuY29tIiwic3ViIjoiWVRNTTRBWmJWbnRKM092Zm5fX0hkNVFBdHJzWVFhaC03Ull6ZUxUTTVidyIsInRpZCI6ImU5ZGFiZTBiLTlmNzgtNDJlMi05ZjBjLWQyOGE3MDJjZWMwZiIsInV0aSI6IlQ1ZTV2UWtjaVVDVW0zcTBLeWtXQUEiLCJ2ZXIiOiIyLjAifQ.kvlpg82uHnY90p5vmNp514TiUKo3HOKK8PTcdFi_o33h2Vf3OMZbKouJEdroAw0ke8mncaoJ_BYwHlT1DHW-NjACwZJ1XssgrYWJXpy_EJEWBesBwajwTTPWDhgMvli7QNe_3e6-Le90FR2OpxRF1-3By2pl0yo3HKKFB_HYyhuqAiK4FfENvJ9izAKGhyjxD2WuQVhk2br0pnU7Yqg3Buz2vpTCI1ERwmSDvPAZdV4QtNPgOWWvg_tjG1lgpm8xrIIoE_3Kw-9L4lGFUwgZaovPul0f3Mr7yBrywOPY5oZ1z8d-DD82oOFVTZhHy-xV_tS677fDMCRXcujRjoYa6A",
      refreshToken: "",
      eventType: "Init",
      oauthType: "microsoft"
    });
    this.handleMerchId("524A8FED-E123-4015-9A87-31CB4CDFCA1A");
    this.$router.replace({ name: "Orders" });
  }

  public get isTabletLogin() {
    let { isPad } = this.$route.query;
    let openInBrowser = this.$store.state.openInBrowser;
    if (isPad || openInBrowser || sessionStorage.getItem("openInBrowser")) {
      return true;
    }
    return false;
  }

  public get showDevButton(): boolean {
    return window.config.showDev;
  }

  toTeamAndConditionPage() {
    event("toTeamAndConditionPage", "");
  }

  toPrivacyPoliciesPage() {
    event("toPrivacyPoliciesPage", "");
  }

  mounted() {
    const token: string = sessionStorage.getItem("token") as string;
    const merchId: string = sessionStorage.getItem("merchId") as string;
    const isopenInBrowser: string = sessionStorage.getItem(
      "openInBrowser"
    ) as string;
    const loginMerchant: string = sessionStorage.getItem(
      "loginMerchant"
    ) as string;
    const oauthType: string = sessionStorage.getItem("oauthType") as string;
    const param = {
      token,
      oauthType,
      merchId,
      isopenInBrowser,
      loginMerchant
    };
    if (token && merchId && isopenInBrowser) {
      sessionStorage.setItem("isLogin", "true");
      this.$store.commit("handleRefreshPage", param);
      this.$router.replace({ name: "Orders" });
    }
    event("toOrderPage", "");
    const clientWidth: number = window.screen.width * window.devicePixelRatio;
    const clientHeight: number = window.screen.height * window.devicePixelRatio;
    switch (clientWidth) {
      case deviceWidth.Iphone678P:
        this.loginImage = loginImageIphone678P;
        break;
      case deviceWidth.Iphone678:
        this.loginImage = loginImageIphone678;
        break;
      case deviceWidth.Iphonex:
        this.loginImage = loginImageIphonex;
        break;
      case deviceWidth.Iphonexr:
        this.loginImage = loginImageIphonexr;
        break;
      default:
        this.loginImage = loginImagePad;
    }
    if (clientWidth === 1242 && clientHeight === 2688) {
      this.loginImage = loginImageIphonexsMax;
    }
  }
}
